import { lastValueFrom } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';

import ApiBase from './ApiBase';

export default class CustomerLoyaltyService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/customerLoyaltyProgram');

  getCustomerLoyaltyByStoreId(storeId) {
    return lastValueFrom(this.api.getJSON(`${CustomerLoyaltyService.baseUrl}/getByStoreId/${storeId}`));
  }
}
